import Plugin from './index';
import store from '../../../store';

const HISTORY_EVENTS = ['replaceState', 'pushState', 'popstate', 'hashchange'];

class PageRerenderPlugin extends Plugin {
  name = 'pageRerender';
  private latestFireUrl = '';

  init() {
    const { spa, enableVisualization } = store.config;
    if (spa && enableVisualization) {
      HISTORY_EVENTS.forEach(event => window.addEventListener(event, () => {
        this.rerenderHottag();
      }));
    }
  }

  // 重新渲染页面热点
  private rerenderHottag() {
    setTimeout(() => {
      const firedUrl = window.location.pathname + window.location.hash;
      // 如果 url 并没有发生变化时，没有必要上报
      if (!this.instance.uin || !firedUrl || firedUrl === this.latestFireUrl) {
        return;
      }

      this.instance.renderHottag();

      // 记录最新 url
      this.latestFireUrl = firedUrl;
    }, 0);
  }
}

export default PageRerenderPlugin;
